import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import Constants from '../../../definitions/constants';
import TableDescriptors from '../../../definitions/tableDescriptors';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import FormatTooling from '../../../tooling/formatTooling';
import EntityTableTooling from '../../../tooling/entityTableTooling';
import { intl } from '../../../locales/localesConfig';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import LocaleTooling from '../../../tooling/localeTooling';
import toastr from 'toastr';

/* Actions */
import * as supervisorRevisionActions from '../../actions/supervisorRevisionPanel/index';
import * as dashboardActions from '../../actions/dashboard/index';

/*Components*/
import FullScreenGlassLoading from '../../components/common/interface/fullScreenGlassLoading';
import EntityTable from '../../components/common/entity/entityTable';
import GlassConfirmWithNotesPopup from '../../components/common/interface/glassConfirmWithNotesPopup';
import GlassConfirmPopup from '../../components/common/interface/glassConfirmPopup';
import SupervisorActions from '../../components/supervisorRevisionPanel/supervisorActions';
import Header from '../../components/supervisorRevisionPanel/header';
import RevisionsHeader from '../../components/supervisorRevisionPanel/revisionsHeader';
import ErrorLoadingView from '../../components/common/interface/errorLoadingView';
import Select from '../../components/common/inputs/select';
import RevisionActionsHistoryPopup from '../../components/supervisorsAdminRevisionPanel/revisionActionsHistoryPopup';

const popupIds = {
  setReviewStatePopup: "setReviewStatePopup",
  setReviewStateConfirmPopup: "setReviewStateConfirmPopup",
  revisionActionsHistoryPopup: "revisionActionsHistoryPopup",
}

const initialState = {
  dataFilters: {
    periodIdSelected: "",
  },
  allRevisionsListFilters: {
    model_revisions_filter: "",
    model_states_filter: "",
  },
  actionRevisionId: "",
  actionRevisionState: "",
  actionModelName: "",
  actionNotes: "",
  actionNewState: "",
  revisionActionsHistoryInfo: null,
};

class SupervisorRevisionPanel extends Component {
  constructor(props) {
    super(props);
    this.state = JavascriptUtilsTooling.deepCopy(initialState);
  }
 
  async componentDidMount() {    
    await this.props.actions.getPeriodsList();
    await this.props.actions.getModelsList();
  }
  
  componentWillUnmount() {
    this.props.actions.reset();
  }

  componentDidUpdate(prevProps) {
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.setRevisionStatus.status],
      [this.props.setRevisionStatus.status],
      intl.formatMessage({id: "supervisorRevisionPanel.revisionActionSuccess"}),
      intl.formatMessage({id: "supervisorRevisionPanel.revisionActionError"}),
      [() => {
        if(InterfaceTooling.popupHasToRender(this.state[popupIds.setReviewStateConfirmPopup])) {
          InterfaceTooling.popupHide(popupIds.setReviewStateConfirmPopup, this.setState.bind(this));
        }
        if(InterfaceTooling.popupHasToRender(this.state[popupIds.setReviewStatePopup])) {
          InterfaceTooling.popupHide(popupIds.setReviewStatePopup, this.setState.bind(this));
        }
        this.props.actions.getRevisionsList(this.getRevisionsListQueryParams(this.props.fixedPeriodId || this.state.dataFilters.periodIdSelected));
        this.props.actions.getAllRevisionsList(this.getAllRevisionsListQueryParams(this.props.fixedPeriodId || this.state.dataFilters.periodIdSelected));
      }]
    );

    InterfaceTooling.apiCallResultFeedback(
      [prevProps.downloadRevision.status],
      [this.props.downloadRevision.status],
      intl.formatMessage({ id: "supervisorRevisionPanel.downloadRevisionFileSuccess" }),
      intl.formatMessage({ id: "supervisorRevisionPanel.downloadRevisionFileFailure" })
    );

    if(this.props.periodsList.status===200 && prevProps.periodsList.status !==200) {
      if(this.props.periodsList.data.length > 0) {
        let periodIdSelected = this.props.periodsList.data[0].id;
        let selectedPeriod = null;
        if(this.props.fixedPeriodId!="") {
          selectedPeriod = this.props.periodsList.data.find(item => item.id==this.props.fixedPeriodId);
          periodIdSelected = selectedPeriod ? selectedPeriod.id : null;
        }
        this.state.dataFilters.periodIdSelected = periodIdSelected;
        this.state.selectedPeriodName = selectedPeriod ? selectedPeriod.name : "";
        this.props.actions.setPeriodId(periodIdSelected);
        this.props.actions.getRevisionsList(this.getRevisionsListQueryParams(periodIdSelected));
        this.props.actions.getAllRevisionsList(this.getAllRevisionsListQueryParams(periodIdSelected));
      }
    }
  }

  // ==============
  // SUPERVISOR REVISIONS LIST UTILS
  getRevisionsListQueryParams = (periodId) => {
    let queryParams = {
      page: this.props.revisionsList.page,
      per_page: Constants.interface.supervisorRevisionsPageSize,
      current_user: true,
      period_id: periodId
    };
    return queryParams;
  }
  
  fetchRevisionsListNextPage = async (event) => {
    var page = +event.currentTarget.dataset.targetpage;
    if(this.props.revisionsList.status === 200 && this.props.revisionsList.page<=this.props.revisionsList.totalPages) {
      await this.props.actions.getRevisionsList(Object.assign(this.getRevisionsListQueryParams(this.state.dataFilters.periodIdSelected), {
        page: page,
      }), true);
    }  
  }
  // ===============

  // ALL REVISIONS LIST UTILS
  getAllRevisionsListQueryParams = (periodId) => {
    let queryParams = {
      page: this.props.allSupervisorsRevisionsList.page,
      per_page: Constants.interface.supervisorRevisionsPageSize,
      period_id: periodId,
      current_user_models: true,
      model_revisions_filter: this.state.allRevisionsListFilters.model_revisions_filter,
      model_states_filter: this.state.allRevisionsListFilters.model_states_filter
    };
    return queryParams;
  }

  fetchAllRevisionsListNextPage = async (event) => {
    var page = +event.currentTarget.dataset.targetpage;
    if(this.props.allSupervisorsRevisionsList.status === 200 && this.props.allSupervisorsRevisionsList.page<=this.props.allSupervisorsRevisionsList.totalPages) {
      await this.props.actions.getAllRevisionsList(Object.assign(this.getAllRevisionsListQueryParams(this.state.dataFilters.periodIdSelected), {
        page: page,
      }), true);
    }  
  }
  // ===============

  handleOnChangePeriod = (event) => {
    let value = event.target.value;
    let newState = JavascriptUtilsTooling.deepCopy(initialState);
    let selectedPeriod = this.props.periodsList.data.find(item => item.id==value);
    newState.dataFilters.periodIdSelected = value;
    newState.selectedPeriodName = selectedPeriod ? selectedPeriod.name : "";
    this.setState(newState);
    this.props.actions.softReset();
    this.props.actions.setPeriodId(newState.dataFilters.periodIdSelected);
    this.props.actions.getModelsList();
    this.props.actions.getRevisionsList(this.getRevisionsListQueryParams(selectedPeriod.id));
    this.props.actions.getAllRevisionsList(this.getAllRevisionsListQueryParams(selectedPeriod.id));
  };

  handleDownloadRevision = async (event) => {
    event.stopPropagation();
    let entityData = JSON.parse(event.currentTarget.dataset.entitydata);
    await this.props.actions.downloadRevision({
      revision_id: entityData.id,
      revision_file_name: entityData.revision_file_name
    });
  }

  // ============
  // ACTIONS
  handleShowActionPopup = (event) => {
    event.stopPropagation();
    InterfaceTooling.handleShowPopup(event, popupIds.setReviewStatePopup, 
      this.state, this.setState.bind(this), this.props.setRevisionStatus.loading, () => {
        let modelRevision = JSON.parse(event.currentTarget.dataset.entitydata);
        this.setState({
          actionRevisionId: modelRevision.revision_id,
          actionRevisionState: modelRevision.revision_state,
          actionModelName: modelRevision.polynomial_name
        });
      });
  }

  handleShowActionConfirmPopup = (event) => {
    InterfaceTooling.handleShowPopup(event, popupIds.setReviewStateConfirmPopup, 
      this.state, this.setState.bind(this), this.props.setRevisionStatus.loading, () => {
        this.setState({
          actionNotes: "",
          actionNewState: event.currentTarget.dataset.action,
        });
      });
  }

  handleOnClickActionConfirm = async () => {
    let params = {
      period_id: this.state.dataFilters.periodIdSelected,
      revision_id: this.state.actionRevisionId,
      supervisor_message: this.state.actionNotes,
      new_revision_state: this.state.actionNewState,
    }
    this.props.actions.setRevisionStatus(params);
  }

  handleOnChangeActionNotes = (event) => {
    this.setState({
      actionNotes: event.currentTarget.value,
    });
  }
  // ============

  handleRefreshPage = async () => {
    await this.props.actions.getPeriodsList();
    await this.props.actions.getModelsList();
  }

  handleOnChangeAllRevisionsListFilters = (event) => {
    let path = event.currentTarget.dataset.path;
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    let allRevisionsListFiltersNew = JavascriptUtilsTooling.deepCopy(this.state.allRevisionsListFilters);
    allRevisionsListFiltersNew[path] = value;
    this.setState({
      allRevisionsListFilters: allRevisionsListFiltersNew,
    });
    let queryParams = this.getAllRevisionsListQueryParams(this.state.dataFilters.periodIdSelected);
    queryParams[path] = value;
    this.props.actions.getAllRevisionsList(queryParams);
  }

  handleModelRevisionRowClick = (event) => {
    let modelRevision = JSON.parse(event.currentTarget.dataset.entitydata);
    let allRevisionsListFiltersNew = JavascriptUtilsTooling.deepCopy(this.state.allRevisionsListFilters);
    allRevisionsListFiltersNew["model_revisions_filter"] = modelRevision.polynomial_id;
    this.setState({
      allRevisionsListFilters: allRevisionsListFiltersNew,
    });
    let queryParams = this.getAllRevisionsListQueryParams(this.state.dataFilters.periodIdSelected);
    queryParams["model_revisions_filter"] = modelRevision.polynomial_id;
    this.props.actions.getAllRevisionsList(queryParams);
  };

  handleViewActionsHistory = async (event) => {
    event.stopPropagation();
    InterfaceTooling.handleShowPopup(event, popupIds.revisionActionsHistoryPopup, 
      this.state, this.setState.bind(this), false, () => {        
        let revision_object = JSON.parse(event.currentTarget.dataset.entitydata);
        this.setState({
          revisionActionsHistoryInfo: {
            revision_id: revision_object.revision_id,
            polynomial_name: revision_object.polynomial_name,
            supervisor_email: revision_object.supervisor_email
          }
        });
        this.props.actions.getSupervisorModelRevisionHistory({
          revision_id: revision_object.revision_id
        });
      });
  }

  render() {
    var loadingView = (this.props.periodsList.firstLoading || this.props.periodsList.loading) ||
    (this.props.modelsList.firstLoading || this.props.modelsList.loading) || (
      (this.props.revisionsList.firstLoading || this.props.revisionsList.loading || this.props.allSupervisorsRevisionsList.firstLoading) && 
      this.props.periodsList.status == 200 && this.props.periodsList.data.length>0);
    var errorLoadingView = (this.props.periodsList.status !== null && this.props.periodsList.status !== 200) || 
      (this.props.revisionsList.status !== null && this.props.revisionsList.status !== 200) || 
      (this.props.allSupervisorsRevisionsList.status !== null && this.props.allSupervisorsRevisionsList.status !== 200) || 
      (this.props.modelsList.status !== null && this.props.modelsList.status !== 200);
    var noPeriodsCreated = this.props.periodsList.status == 200 && this.props.periodsList.data.length==0;
    return (
      <section className="dashboard_content_inner_view entity_admin_container supervisor_revision_panel_container">
        {(!loadingView) && (  
          <i 
            className={"fas fa-sync top_refresh_button"}
            onClick={this.handleRefreshPage}
          />
        )}
        {
          loadingView ? (<FullScreenGlassLoading/>) :
          noPeriodsCreated ? (
            <section className={"supervisors_revision_panel_no_period_wrapper"}>
              <div className="supervisor_revision_panel_container_data_section">
                <Header/>
                <div className="no_period_selected_wrapper">
                  {intl.formatMessage({ id: "common.noPeriodCreated" })}
                </div>
              </div>
            </section>            
          ) :
          errorLoadingView ? (<ErrorLoadingView/>) :
          (
            <section className={"left_filter_fixed_section_parent left_filter_fixed_section_parent_collapse"}>
              <div className="left_filter_right_section supervisors_admin_revision_panel_container_data_section small_table_components">
                <Select
                  className="supervisor_revision_panel_filters_wrapper_period_selector"
                  disabled={this.props.fixedPeriodId!=""}
                  value={this.state.dataFilters["periodIdSelected"]}
                  onChange={this.handleOnChangePeriod}
                  labelLocale={<FormattedMessage id="common.periodSelectLabel"/>}
                  options={InterfaceTooling.getSelectArrayFromArrayOfObjects(this.props.periodsList.data, "id", "name", false)}
                />   
                <Header />
                <EntityTable
                  entityTableDescriptor={TableDescriptors.myRevisionsList}
                  data={this.props.revisionsList.data}
                  loading={this.props.revisionsList.loading}
                  page={this.props.revisionsList.page}
                  totalPages={this.props.revisionsList.totalPages}
                  totalRecords={this.props.revisionsList.totalRecords}
                  fetchListChangePage={this.fetchRevisionsListNextPage}
                  handleRowClick={this.handleModelRevisionRowClick}
                  noSelectedText={<FormattedMessage id={"supervisorsAdminRevisionPanel.noRevisionsHistory"}/>}
                  handleCustomActions={[this.handleDownloadRevision, this.handleShowActionPopup, this.handleViewActionsHistory]}
                  customActionsIcons={["file-excel", "edit", "clipboard-list"]}
                  customActionsTooltips={[
                    intl.formatMessage({ id: "supervisorsAdminRevisionPanel.downloadRevisionTooltip"}),
                    intl.formatMessage({ id: "supervisorRevisionPanel.revisionTooltip"}),
                    intl.formatMessage({ id: "supervisorsAdminRevisionPanel.actionsHistoryTooltip"})
                  ]}
                  conditionalCustomActionHide={["is_revision_inactive", "is_revision_inactive"]}
                  colorConfig={[{
                    color: "green",
                    column: "revision_state",
                    value: Constants.supervisorsAdmin.revisionStatus.APPROVED
                  },{
                    color: "red",
                    column: "revision_state",
                    value: Constants.supervisorsAdmin.revisionStatus.REJECTED
                  },{
                    color: "yellow",
                    column: "revision_state",
                    value: Constants.supervisorsAdmin.revisionStatus.NOT_REVIEWED
                  }]}
                />
                <RevisionsHeader
                  modelsData={this.props.modelsList.data}
                  filterValues={this.state.allRevisionsListFilters}
                  onChangeFilter={this.handleOnChangeAllRevisionsListFilters}
                />
                <EntityTable
                  entityTableDescriptor={TableDescriptors.allSupervisorsRevisionsList}
                  data={this.props.allSupervisorsRevisionsList.data}
                  loading={this.props.allSupervisorsRevisionsList.loading}
                  page={this.props.allSupervisorsRevisionsList.page}
                  totalPages={this.props.allSupervisorsRevisionsList.totalPages}
                  totalRecords={this.props.allSupervisorsRevisionsList.totalRecords}
                  fetchListChangePage={this.fetchAllRevisionsListNextPage}
                  noSelectedText={<FormattedMessage id={"supervisorsAdminRevisionPanel.noRevisionsHistory"}/>}
                  colorConfig={[{
                    color: "green",
                    column: "revision_state",
                    value: Constants.supervisorsAdmin.revisionStatus.APPROVED
                  },{
                    color: "red",
                    column: "revision_state",
                    value: Constants.supervisorsAdmin.revisionStatus.REJECTED
                  },{
                    color: "yellow",
                    column: "revision_state",
                    value: Constants.supervisorsAdmin.revisionStatus.NOT_REVIEWED
                  }]}
                />
                <RevisionActionsHistoryPopup
                  handleShowPopup={this.handleViewActionsHistory}
                  revisionActionsHistoryInfo={this.state.revisionActionsHistoryInfo}
                  revisionActionsHistoryData={this.props.supervisorModelRevisionHistory.data}
                  fullLoading={this.props.supervisorModelRevisionHistory.loading}
                  popupState={this.state[popupIds.revisionActionsHistoryPopup]}
                />        
                <GlassConfirmPopup
                  confirmTitle={(<FormattedMessage 
                    id={"supervisorRevisionPanel.reviewActionConfirmTitle"}
                    values={{modelName: this.state.actionModelName}}
                  />)}
                  confirmText={(<FormattedMessage id={"supervisorRevisionPanel.revisionActionsStepTitle"}/>)}
                  handleCancel={this.handleShowActionPopup}
                  hideCancel={true}
                  popupState={this.state[popupIds.setReviewStatePopup]}
                  loading={this.props.setRevisionStatus.loading}
                >
                  <SupervisorActions
                    handleActionButtons={this.handleShowActionConfirmPopup}
                    revisionState={this.state.actionRevisionState}
                  />
                </GlassConfirmPopup>
                <GlassConfirmWithNotesPopup
                  confirmTitle={(<FormattedMessage 
                    id={"supervisorRevisionPanel.reviewActionConfirmTitle"}
                    values={{modelName: this.state.actionModelName}}
                  />)}
                  confirmText={(<FormattedMessage id={"supervisorRevisionPanel.reviewActionConfirm"}/>)}
                  handleConfirm={this.handleOnClickActionConfirm}
                  handleCancel={this.handleShowActionConfirmPopup}
                  popupState={this.state[popupIds.setReviewStateConfirmPopup]}
                  loading={this.props.setRevisionStatus.loading}
                  notesValue={this.state.actionNotes}
                  notesLabelLocale={intl.formatMessage({ id:"supervisorRevisionPanel.reviewActionNotesLabel"})}
                  handleOnChangeNotes={this.handleOnChangeActionNotes}
                />
              </div>
            </section>
          )
        }
      </section>
    );
  }
}

const mapStateToProps = state => ({
  downloadRevision: state.reducer.supervisorRevisionPanel.downloadRevision,
  setRevisionStatus: state.reducer.supervisorRevisionPanel.setRevisionStatus,
  revisionsList: state.reducer.supervisorRevisionPanel.revisionsList,
  allSupervisorsRevisionsList: state.reducer.supervisorRevisionPanel.allSupervisorsRevisionsList,  
  supervisorModelRevisionHistory: state.reducer.supervisorRevisionPanel.supervisorModelRevisionHistory,
  modelsList: state.reducer.supervisorRevisionPanel.modelsList,
  periodId: state.reducer.supervisorRevisionPanel.periodId,
  fixedPeriodId: state.reducer.dashboard.fixedPeriodId,
  periodsList: state.reducer.supervisorRevisionPanel.periodsList,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(supervisorRevisionActions, dispatch),
  dashboardActions: bindActionCreators(dashboardActions, dispatch),
});

SupervisorRevisionPanel.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SupervisorRevisionPanel);



// WEBPACK FOOTER //
// ./source/client/containers/supervisorRevisionPanel/index.jsx